import React, { Component } from 'react';
import { CodetableListItemsProps } from './types';
import { CodetableItemLoader } from 'app/area/shared/codetable/item/codetable-item-loader';
import { HierarchyMetadata } from 'app/area/shared/codetable/list-item/types';
import { CodetableItemRow } from './common/codetable-item-row';
import { CodetableListItemsContainer } from './codetable-list-items-container';
import { CodetableItem } from './codetable-item';
import { CategoryHeading } from 'app/area/import-mappings/list-items/components/category-heading';

export class CodetableListItems extends Component<CodetableListItemsProps> {

  public render() {

    const { codetable, itemAccess, fetchingItemAccess, parentId, codeListBranch, currentCode,
      codeListBranchState, isZebra, isHierarchyMode, isHierarchy, isCodetableWithCategory,
      updating, metadata, validation, modifiedItems, treeDepthLevel, hierarchyMetadata, translation,
      loadFromParent, expandCodeItem, setCurrentCode, clearValidation } = this.props;

    const currentBranch = codeListBranch.find(item => item.id === parentId);
    const currentCodeItem = currentBranch && currentBranch.items || [];

    const currentBranchState = codeListBranchState && codeListBranchState.find(state => state.id === parentId);
    const fetching = !!currentBranchState && !!currentBranchState.fetching;
    const needsReload = !!currentBranchState && !!currentBranchState.needsReload;

    return <>
      <CodetableListItemsContainer
        parentId={parentId}
        codeBranch={currentBranch}
        codeBranchState={currentBranchState}
        loadFromParent={loadFromParent}>

        {!parentId && isCodetableWithCategory
          && <CategoryHeading codetableName={codetable?.description} metadata={metadata} />}

        {currentCodeItem.map((codeItem, index) => {

          const codeItemState = codeListBranchState && codeListBranchState.find(state => state.id === codeItem.id);
          const open = !!codeItemState && !!codeItemState.open;

          const showSpinner = !!codeItemState && codeItemState.isUpdatingParent && codeItemState.id === codeItem.id;

          const isZebraValue = isZebra === undefined ? index % 2 === 0 : isZebra;

          const isLastChild = !!currentCodeItem && currentCodeItem.length === index + 1;

          const hasChildren = isHierarchyMode && !!codeItem.childrenCount;

          const hierarchyMetadataUpdated: HierarchyMetadata[] = [...hierarchyMetadata, {
            depthLevel: treeDepthLevel,
            hasChildren,
            isLastChild
          }];

          return <div key={codeItem.id}>
            <CodetableItem
              codetable={codetable}
              metadata={metadata}
              currentCode={currentCode}
              itemAccess={itemAccess}
              fetchingItemAccess={fetchingItemAccess}
              isZebra={isZebraValue}
              hierarchyMetadata={hierarchyMetadataUpdated}
              treeDepthLevel={treeDepthLevel}
              refetching={fetching && needsReload || showSpinner}
              isHierarchyMode={isHierarchyMode}
              isHierarchy={isHierarchy}
              isCodetableWithCategory={isCodetableWithCategory}
              open={open}
              parentId={parentId}
              codeItem={codeItem}
              expandCodeItem={expandCodeItem}
              modifiedItems={modifiedItems}
              updating={updating}
              validation={validation}
              setCurrentCode={setCurrentCode}
              clearValidation={clearValidation}
              translation={translation}
              isLastChild={!open && isLastChild}
            />
            {open && <div>
              <CodetableListItems
                {...this.props}
                hierarchyMetadata={hierarchyMetadataUpdated}
                parentId={codeItem.id}
                treeDepthLevel={treeDepthLevel + 1}
                isZebra={isZebraValue}
              />
            </div>}
          </div>;
        })}
      </CodetableListItemsContainer>
      {fetching && !needsReload && <CodetableItemRow isZebra={isZebra} isLoader>
        <CodetableItemLoader>
          {translation.loading}
        </CodetableItemLoader>
      </CodetableItemRow>}
    </>;
  }
}
